import { PokusLobs } from '@mmt/legacy-commons/Native/AbConfig/AbConfigKeyMappings';
import {
  getPokusConfig,
  getPokusConfigForTracking,
} from '@mmt/legacy-commons/Native/AbConfig/AbConfigModule';
import { checkIfHdfcSmartBuy } from './Utils/RailsConstant';
import { Platform } from 'react-native';
import { REGULAR_LOGIN_FLOW, TRAVELER_COMPONENT_DEFAULT_ORDERING} from "./Utils/RailsConstant";
import {PDTclientSchemaV2new} from './RailsAbConstants';

export const RailsAbConfig = {
  railsTravelersAdvisory: 'rails_travelers_advisory',
  railsTravelersComponentOrder: 'rails_travelers_segment_order',
  railsSortAndFilterRevamp: 'rails_listing_filter_revamp',
  railsSortAndFilterRevampClass: 'rails_listing_filter_revamp_class',
  railsSortAndFilterRevampAvailability: 'rails_listing_filter_revamp_availability',
  railsNuLpBanner: 'Rails_NU_LP_Banner',
  railsAppTamilVernac: 'railsAppTamilVernac',
  railsRISsectionLTStileNewIconTag: 'rail_lts_rislp_new_tag',
  railsTGSrislpIconWithNewTag: 'rails_tgs_rislp_icon_witnewtag',
  railsTGSCarouselTag: 'rails_tgs_rislp_carousel_order',
  railsCalendarVersion: 'rails_calendar_version',
  railsLtsEnableOfflinePIPMode: 'rails_ris_lts_offline_pip',
  railsLtsEnabledStationAlarm: 'Rails_RIS_LTS_StationAlarm_ONOFF',
  railsLtsEnableDynamicSpeedComputation: 'rails_ris_lts_offline_speed_computation',
  railsEnableLtsImprovementChanges: 'rails_enable_lts_improvement_changes',
  railsInsuranceDefaultSelected: 'rails_travelers_insurance_default',
  railsAgentTxnErrorRetry: 'rails_agent_txn_error_retry',
  railsReportGPSErrors: 'railsReportGPSErrors',
  railsReportCTErrors: 'railsReportCTErrors',
  railsTravelersIRCTCaccountToast: 'rails_travelers_irctc_account_toast',
  railsTGSAppFunnelNativeOrMweb: 'Rails_TGS_Apps_funnel_payments_Native_vs_Mweb',
  showStationChangeAlert: 'rails_listing_nearbystation_bottomsheet',
  railsRISiconPaletteVersion: 'rails_rislp_risiconpallete_version',
  railsWhatsAppMessage:'rails_tgs_whatsapp',
  railsTravelerLoginFlow: 'rails_travelers_login_push',
  railsTravelersFCBottomSheet: 'rails_travelers_fc_prompt',
  showBusTrainCrossSell: 'rails_bus_cross_pnrpage',
  railsRouteExtenstionBottomsheet: 'rails_route_extension_bottomsheet',
  railsRouteExtensionV2: 'rails_route_extension_v2',
  priceBreakupCollapsed: 'rails_review_fare_breakup_collapsed',
  railsTravelerResistanceBottomsheet: 'rail_travelers_back_resistance',
  railsReviewPageResistanceBottomsheet: 'rail_review_back_resistance',
  railsListingSortingLogic: 'rails_listing_sorting_logic',
  railsTravelersFCBottomSheet: 'rails_travelers_fc_prompt',
  railsOldPNRPage: 'rails_old_pnr_page',
  railsFcWidgetNew: 'rails_fc_widget_new',
  railsTravelersBottomSheetContactDetails: 'rails_travelers_cd_prompt',
  railsThankyouPageCouponLounge : 'rails_thankyou_couponlounge',
  railsReportIrctcErrors:'railsReportIrctcErrors',
  railsAdfeedOnListing:'rails_listing_adfeed_onapps',
  railsIrctcNewReloadButton : 'rails_irctc_new_reload_button',
  railsNewTgWidget: 'rail_tg_widget_rac_apps',
  railsTGFCTogether: 'mmt.app.rail.default.listing.default.rails_FC_TG_V1',
  railsCanLoadListingV3:
    'mmt.default.rail.default.default.default.rails_listing_load_time_improvements',
  railsTGFCTogetherPrompt: 'mmt.app.rail.default.listing.default.rail_fc_and_tg_prompt',
  railsReportCustomFirebaseErrors:
    'mmt.app.rail.default.default.default.report_custom_firebase_errors',
  railsFcPrefCache: 'mmt.app.rail.default.default.default.rails_fc_cachepref_final',
  railsCanAutoReloadIRCTC: 'mmt.app.rail.default.default.default.rails_auto_reload_irctc',
  railsShowBNPPv1: Platform.OS === 'web' ? 'mmt.pwa.rail.default.default.default.rails_bnpp_v1_pwa':'mmt.app.rail.default.default.default.rails_bnpp_v1',
  //ABCleanup:rails_ris_lts_location_choice on 4th Jan 24 defaulting to false
  tgsTandCwhatsappTag: 'mmt.app.rail.default.default.default.tgs_TandC_whatsappTag',
  enableGrafanaLogger: 'mmt.app.rail.default.default.default.rails_enable_grafana_logger',
  railsRisGPTConfig: 'mmt.pwa.rail.default.default.default.rails_ris_gpt_config_mweb',
  railsFCBNPPPrompt: 'mmt.app.rail.default.review.default.rail_fc_bnpp_prompt',
  railsConnectedTravel: 'mmt.app.rail.default.default.default.rail_connected_travel',
  railsCanEnableEnvSwitch: 'mmt.app.rail.default.default.default.rail_enable_env_switch',
  railsTGPlus: 'mmt.app.rail.default.default.default.rails_tg_plus',
  railsEnableLTSErrorLogging: 'mmt.app.rail.default.default.default.lts_enable_error_logging',
  railsOfflineSwitchingLogic: 'mmt.app.rail.default.default.default.lts_offline_switching_logic',
  railsFcCallout: 'mmt.app.rail.default.default.default.rail_fc_callout',
  rails_tg_wl_green: 'mmt.app.rail.default.default.default.rails_tg_wl_green',
  railsNearbyDatesRevamp: Platform.OS === 'web' ? 
    'mmt.pwa.rail.default.listing.default.pwa_rails_nearbydates' : 
    'mmt.app.rail.default.default.default.rail_nearbydates',
  railsOtherDaytrains: 'mmt.app.rail.default.default.default.rails_odt',
  railsTgLowCpBucket: 'mmt.app.rail.default.default.default.show_TG_low_CP_1',
  railsShowRouteExtenstion: 'mmt.app.rail.default.default.default.rail_re',
  railsErrorHandling: 'mmt.app.rail.default.default.default.rail_error_handling',
  railsTravellerPdtConfigNew: 'mmt.app.rail.default.default.default.rail_traveller_pdt_config_new',
  railsListingErrorRetry: 'mmt.app.rail.default.default.default.rail_error_handling_listing',
  railsConnectedTravelV2: 'mmt.app.rail.default.default.default.rails_ct_v2',
  railsConnectedTravelSource: 'mmt.app.rail.default.listing.default.rail_ct_source',
  railsLDAndSSQuotaEnabled: 'mmt.app.rail.default.default.default.rails_ld_and_ss_quota_enabled',
  railsShowBNPPtooltip: 'mmt.app.rail.default.default.default.rails_seatlock_affordance',
  railsListingMeasurementPlatformPdtLogging:
    'mmt.app.rail.default.default.default.rail_listing_pdt_config_new',
  railsLandingMeasurementPlatformPdtLogging:
    'mmt.app.rail.default.default.default.rail_landing_pdt_config_new',
  railsReviewMeasurementPlatformPdtLogging:
    'mmt.app.rail.default.default.default.rail_review_pdt_config_new',
  railsCanLogCustomErrorsToSentry:
    'mmt.app.rail.default.default.default.rails_custom_sentry_tracking',
  railsNextMweb: 'mmt.pwa.rail.default.default.default.railsNextMweb',
  railsRouteExtenstionBottomsheetVariant:
    'mmt.app.rail.default.default.default.Route_Extension_BottomSheet_Variants',
  railsNearbyDatesVariants: Platform.OS === 'web' ? 
    'mmt.pwa.rail.default.listing.default.pwa_nearby_dates_test_variants' : 
    'mmt.app.rail.default.listing.default.nearby_dates_test_variants_v1',
  railsTbsErrorHandlingFlowV1:
    'mmt.app.rail.default.default.default.mmt_rails_listing_error_flows',
  railsFcTgTogether: 'mmt.pwa.rail.default.default.default.rails_fc_tg_together_mweb',
  railsAvailabilitySubscription: Platform.OS === 'web' ? 
    'mmt.pwa.rail.default.default.default.rails_avl_alert_mweb' : 
    'mmt.app.rail.default.detail.default.rails_avl_alert',
  railsSeatLockReviewVariants: 'mmt.app.rail.default.default.default.Seatlock_Review_Page_Variants',
  railsSeatLockListingVariants: 'mmt.app.rail.default.detail.default.SeatLock_Listing_variants',
  railsConnectedTravelCard: 'mmt.app.rail.default.default.default.rails_ctCardV2',
  railsAvailDepletion: Platform.OS === 'web' ? 
    'mmt.pwa.rail.default.listing.default.avl_depletion_mweb' :
    'mmt.app.rail.default.listing.default.avl_depletion',
  busRailsPremium: 'mmt.app.rail.default.default.default.bus_rails_premium',
  railsDynamicPrice: 'mmt.app.rail.default.listing.default.rails_dynamic_price_icon',
  railsReviewIrctcBs: Platform.OS === 'web' ? 
    'mmt.pwa.rail.default.review.default.rails_pwa_review_irctc_bottomsheet' : 
    'mmt.app.rail.default.default.default.rails_review_irctc_bottomsheet',
  railsFcPremiumPercentage: 'mmt.app.rail.default.detail.default.fc_premium_percent',
  railsMealsPnrDetails: Platform.OS === 'web' ? 'mmt.pwa.rail.default.default.default.meals_pnr_details_mweb' : 'mmt.app.rail.default.default.default.meals_pnr_details',
  railsMealsLtsDetails: Platform.OS === 'web' ? 'mmt.pwa.rail.default.default.default.meals_lts_details_mweb' : 'mmt.app.rail.default.default.default.meals_lts_details',
  showMealsStaticData: Platform.OS === 'web' ? 'mmt.pwa.rail.default.default.default.show_meals_static_data_mweb' : 'mmt.app.rail.default.default.default.show_meals_static_data',
  railsMealsNewFlow: Platform.OS === 'web' ? 'mmt.pwa.rail.default.default.default.meals_new_flow_mweb' : 'mmt.app.rail.default.default.default.meals_new_flow',
  railsMealsRisDetails: 'mmt.app.rail.default.default.default.meals_ris_section',
  railsMealsTrainThankYou: 'mmt.app.rail.default.default.default.meals_train_thank_you',
  railsTravellerIrctcBottomsheet: Platform.OS === 'web' ? 
    'mmt.pwa.rail.default.default.default.rails_traveller_irctc_bottomsheet_mweb' :
    'mmt.app.rail.default.default.default.rails_traveller_irctc_bottomsheet',
  railsSocialProofingFreeCancellation: Platform.OS === 'web' ? 
    'mmt.pwa.rail.default.review.default.fc_discount_social_1_mweb' :
    'mmt.app.rail.default.review.default.fc_discount_social_1',
  railsSocialProofingTripGuarantee: Platform.OS === 'web' ?
    'mmt.pwa.rail.default.review.default.tg_discount_social_1_mweb' : 
    'mmt.app.rail.default.review.default.tg_discount_social_1',
  railsScheduleTatkal: 'mmt.app.rail.default.default.default.rails_super_tatkal',
  showMyraBotMweb: 'mmt.pwa.rail.default.review.default.rails_myra_mweb',
  railsCouponExperiment: 'mmt.pwa.rail.default.default.default.pwa_mmt_rails_coupon_experiment',
  railsLoggedOutCoupons: 'mmt.pwa.rail.default.default.default.rails_pwa_loggedout_coupons',
  railsPwaOfferCallout: 'mmt.pwa.rail.default.default.default.rails_pwa_offer_callout',
  railsIrctcIncompleteProfileFlow: 'mmt.pwa.rail.default.default.default.mweb_rails_not_authorised_redirection',
  railsV2PDTclientSchema: 'mmt.pwa.rail.default.default.default.pdt_b2c_client_schema_v2_mweb',
  railsTravelplexBot: 'mmt.pwa.rail.default.default.default.rails_mweb_travelplex_bot',
  cabsCrossSellTY: 'mmt.pwa.rail.default.default.default.Rails_TY_Cross_Sell_AB_Mweb'
};

const TRACKING_DISABLED = false;
const TRACKING_NULL = null;

export const getRailsPokusConfig = (configKey, defaultValue) => {
  try {
    return getPokusConfig(PokusLobs.RAIL, configKey, defaultValue);
  } catch (e) {
    return defaultValue;
  }
};

export const getRailsPokusConfigForTracking = (configKey, defaultValue) => {
  try {
    return getPokusConfigForTracking(PokusLobs.RAIL, configKey, defaultValue);
  } catch (e) {
    return defaultValue;
  }
};

export const showRailsMwebNext = () => {
  return getRailsPokusConfig(RailsAbConfig.railsNextMweb, false);
};

export const showBusTrainCrossSell = () => {
  return getRailsPokusConfig(RailsAbConfig.showBusTrainCrossSell, false);
};

export const showCabsCrossSellTY = () => {
  // Hardcoding pokus since pokus is not working on ty page
  return 1;
  // return getRailsPokusConfig(RailsAbConfig.cabsCrossSellTY, 1);
};

export const getRailsListingNewPdtLoggingOnOff = () => {
  return getRailsPokusConfig(RailsAbConfig.railsListingMeasurementPlatformPdtLogging, true);
};

export const getRailsLandingNewPdtLoggingOnOff = () => {
  return getRailsPokusConfig(RailsAbConfig.railsLandingMeasurementPlatformPdtLogging, true);
};

export const getRailsReviewNewPdtLoggingOnOff = () => {
  return getRailsPokusConfig(RailsAbConfig.railsReviewMeasurementPlatformPdtLogging, true);
};

export const getTravelerComponentOrder = () => {
  return getRailsPokusConfig(RailsAbConfig.railsTravelersComponentOrder, TRAVELER_COMPONENT_DEFAULT_ORDERING);
}
export const getGreenWaitlistedComponent = () => {
  if(Platform.OS === 'web'){
    return false; //Green Waitlisted component is not required on MWEB 
  }
  return getRailsPokusConfig(RailsAbConfig.rails_tg_wl_green, false);
};
export const getRailsTravelerAdvisoryOnOff = () => {
  return getRailsPokusConfig(RailsAbConfig.railsTravelersAdvisory, false);
};

export const getRailsSortAndFilterRevamp = () => {
  if(Platform.OS === 'web'){
    return true; //New filter is used for mweb to avoid rerender
  }
  return getRailsPokusConfig(RailsAbConfig.railsSortAndFilterRevamp, true);
};

export const getRailsSortAndFilterRevampClass = () => {
  return getRailsPokusConfig(RailsAbConfig.railsSortAndFilterRevampClass, true);
};

export const getRailsSortAndFilterRevampAvailability = () => {
  return getRailsPokusConfig(RailsAbConfig.railsSortAndFilterRevampAvailability, true);
};

export const getRailsNuLpBanner = () => {
  return getRailsPokusConfig(RailsAbConfig.railsNuLpBanner, false);
};

export const getRailsAppTamilVernac = () => {
  return getRailsPokusConfig(RailsAbConfig.railsAppTamilVernac, false);
};

export const getRISsectionNewTag = () => {
  return getRailsPokusConfig(RailsAbConfig.railsRISsectionLTStileNewIconTag, false);
};

export const getTGSsectionNewTag = () => {
  return getRailsPokusConfig(RailsAbConfig.railsTGSrislpIconWithNewTag, false);
};

export const getTGSCarouselTag = () => {
  return getRailsPokusConfig(RailsAbConfig.railsTGSCarouselTag, 'TGS|LTS');
};

export const getPNRPageConfig = () => {
  return getRailsPokusConfig(RailsAbConfig.railsOldPNRPage, false);
}

export const getTGSWhatsappTag = () => {
  return getRailsPokusConfig(RailsAbConfig.railsWhatsAppMessage, false);
};

export const getTGSTandCWhatsappTag = () => {
  return getRailsPokusConfig(RailsAbConfig.tgsTandCwhatsappTag, false);
};

export const getRailsTGSAppFunnelNativeOrMweb = () => {
  return getRailsPokusConfig(RailsAbConfig.railsTGSAppFunnelNativeOrMweb, '1');
};

export const getV2PDTclientSchema = () => {
  return getRailsPokusConfig(
    RailsAbConfig.railsV2PDTclientSchema,
    PDTclientSchemaV2new.OLD_PDT_SCHEMA_SELECTED,
  );
};

export const getRailsCalendarVersion = () => {
  return getRailsPokusConfig(RailsAbConfig.railsCalendarVersion, 'V1');
};

export const getClusterBottomSheetForStationChangeAlert = () => {
  return getRailsPokusConfig(RailsAbConfig.showStationChangeAlert, false);
};

export const getRisIconPaletteVersion = () => {
  return getRailsPokusConfig(RailsAbConfig.railsRISiconPaletteVersion, '1');
};

export const getRisIconGPTConfig = () => {
  return getRailsPokusConfig(RailsAbConfig.railsRisGPTConfig, 0);
};

//LTS
export const getIsLTSAlarmEnabled = () => {
  return (
    Platform.OS === 'android' &&
    getRailsPokusConfig(RailsAbConfig.railsLtsEnabledStationAlarm, false)
  );
};

export const getIsOfflinePIPModeEnabled = () => {
  return (
    Platform.OS === 'android' &&
    getRailsPokusConfig(RailsAbConfig.railsLtsEnableOfflinePIPMode, false)
  );
};

export const getIsDynamicSpeedComputationEnabled = () => {
  return (
    Platform.OS === 'android' &&
    getRailsPokusConfig(RailsAbConfig.railsLtsEnableDynamicSpeedComputation, false)
  );
};

export const getEnableLtsImprovementChanges = () => {
  return __DEV__
    ? false
    : Platform.OS === 'android' &&
        getRailsPokusConfig(RailsAbConfig.railsEnableLtsImprovementChanges, false);
};

export const getCanReportError = (isGPS = true) => {
  return (
    Platform.OS === 'android' &&
    getRailsPokusConfig(
      isGPS ? RailsAbConfig.railsReportGPSErrors : RailsAbConfig.railsReportCTErrors,
      false,
    )
  );
};

//End of LTS

export const getCanReportIRCTCError = () => {
  return getRailsPokusConfig(RailsAbConfig.railsReportIrctcErrors, false);
};

export const getRailsInsuranceDefaultSelected = () => {
  return getRailsPokusConfig(RailsAbConfig.railsInsuranceDefaultSelected, 1);
};

export const getRailsAgentTxnErrorRetry = () => {
  return getRailsPokusConfig(RailsAbConfig.railsAgentTxnErrorRetry, [3, 5, 7]);
};

/* Travellers Details Pokus */
export const getRailsIrctcAccountToast = () => {
  return getRailsPokusConfig(RailsAbConfig.railsTravelersIRCTCaccountToast, true);
};

export const getTravelerRedesignContactDetailsBottomSheetApproach = () => {
  if(Platform.OS === 'web'){
    return false; //Temorarly disabling for MWEB as issue in bottom sheet
  }
  return getRailsPokusConfig(RailsAbConfig.railsTravelersBottomSheetContactDetails, false);
}

export const getTravelerRedesignFreeCancellationBottomSheetApproach = () => {
  return getRailsPokusConfig(RailsAbConfig.railsTravelersFCBottomSheet, false);
}

export const getLoginFlowType = () => {
  return getRailsPokusConfig(RailsAbConfig.railsTravelerLoginFlow, REGULAR_LOGIN_FLOW);
}
export const getTravelersBackButtonResistanceBottomsheet = () => {
  return getRailsPokusConfig(RailsAbConfig.railsTravelerResistanceBottomsheet, false);
};

export const getReviewPageBackButtonResistanceBottomsheet = () => {
  return getRailsPokusConfig(RailsAbConfig.railsReviewPageResistanceBottomsheet, false);
};

export const getRailsRouteExtenstionV2 = () => {
  return getRailsPokusConfig(RailsAbConfig.railsRouteExtensionV2, true);
};

export const getRailsRouteExtenstionBottomsheet = () => {
  return getRailsPokusConfig(RailsAbConfig.railsRouteExtenstionBottomsheet, true);
};

export const getReviewPagePriceBreakupCollapsed = () => {
  return getRailsPokusConfig(RailsAbConfig.priceBreakupCollapsed, false);
};
export const getRailsListingSortingLogic = () => {
  return getRailsPokusConfig(RailsAbConfig.railsListingSortingLogic, '3');
};

export const getTravelerFreeCancellationBottomSheet = () => {
  return getRailsPokusConfig(RailsAbConfig.railsTravelersFCBottomSheet, false);
};

export const getTravellerFcWidgetNew = () => {
  return getRailsPokusConfig(RailsAbConfig.railsFcWidgetNew, true);
};

export const getThankYouPageCouponLounge = () => {
  return getRailsPokusConfig(RailsAbConfig.railsThankyouPageCouponLounge, true);
};

export const getShowAdsOnListingPokus = () => {
  return getRailsPokusConfig(RailsAbConfig.railsAdfeedOnListing, false);
};

export const getIrctcNewReloadButton = () => {
  return getRailsPokusConfig(RailsAbConfig.railsIrctcNewReloadButton, true);
};

export const getRailsNewTgWidget = () => {
  return getRailsPokusConfig(RailsAbConfig.railsNewTgWidget, false);
};

export const getIfToShowFCTGTogether = () => {
  if(Platform.OS === 'web'){
    return true; //Always show FC TG Together on MWEB
  }
  return getRailsPokusConfig(RailsAbConfig.railsTGFCTogether, false);
}

export const getIfToShowFCTGTogetherPrompt = () => {
  return 2; //experiment concluded, code to be cleaned
  return getRailsPokusConfig(RailsAbConfig.railsTGFCTogetherPrompt, 2);
};

export const getCanLoadListingv3 = () => {
  if(Platform.OS === 'web'){
    return true; //Always listing v3 for mweb
  }
  return getRailsPokusConfig(RailsAbConfig.railsCanLoadListingV3, false);
};

export const getFcPrefCache = () => {
  return getRailsPokusConfig(RailsAbConfig.railsFcPrefCache, false);
};

export const getIfAutoReloadIRCTC = () => {
  return getRailsPokusConfig(RailsAbConfig.railsCanAutoReloadIRCTC, true);
};

export const getIfCanShowBNPP = (forTracking = false) => {
  if(checkIfHdfcSmartBuy()) {
    return false;
  }
  // added a platform check as MWEB is still using pokus V1 api which will always return null for getRailsPokusConfigForTracking
  if (Platform.OS !== 'web' && forTracking) {
    return getRailsPokusConfigForTracking(RailsAbConfig.railsShowBNPPv1, null);
  }
  return getRailsPokusConfig(RailsAbConfig.railsShowBNPPv1, false);
};

export const showMyraBotMwebPokus = (forTracking = false) => {
  if (forTracking !== true && forTracking !== false) {
    throw new Error('Invalid input: forTracking must be a boolean');
  }
  if (forTracking) {
    return getRailsPokusConfigForTracking(RailsAbConfig.showMyraBotMweb, TRACKING_NULL);
  }
  return getRailsPokusConfig(RailsAbConfig.showMyraBotMweb, TRACKING_DISABLED);
};

export const getSeatLockReviewVariants = () => {
  if(checkIfHdfcSmartBuy()) {
    return 0;
  }
  return getRailsPokusConfig(RailsAbConfig.railsSeatLockReviewVariants, 1);
};

export const getIfCanShowNewBNPPTagWhenFC = () => {
  return getRailsPokusConfig(RailsAbConfig.railsFCBNPPPrompt, false);
};

export const getIfCanEnableGrafanaLogger = () => {
  return !__DEV__ && getRailsPokusConfig(RailsAbConfig.enableGrafanaLogger, false);
};

export const getIfToShowRailsConnectedTravel = () => {
  return  getRailsPokusConfig(RailsAbConfig.railsConnectedTravel, false);
};

export const getIfToShowConnectedTravelV2 = () => {
  return getRailsPokusConfig(RailsAbConfig.railsConnectedTravelV2, false);
};

export const getRailsCtSource = () => {
  return getRailsPokusConfig(RailsAbConfig.railsConnectedTravelSource, 3);
};

export const getIfCanEnableEnvSwitch = () => {
  return getRailsPokusConfig(RailsAbConfig.railsCanEnableEnvSwitch, false);
};

export const getRailsTGVersion = (forTracking = false) => {
  if (forTracking) {
    return getRailsPokusConfigForTracking(RailsAbConfig.railsTGPlus, null);
  }
  return getRailsPokusConfig(RailsAbConfig.railsTGPlus, 1);
}

export const getTravellerPdtConfig = () => {
  return getRailsPokusConfig(RailsAbConfig.railsTravellerPdtConfigNew, true);
};

export const getIfEnableLTSErrorLogging = () => {
  return getRailsPokusConfig(RailsAbConfig.railsEnableLTSErrorLogging, false);
};

export const getOfflineSwitchingLogic = () => {
  return getRailsPokusConfig(RailsAbConfig.railsOfflineSwitchingLogic, 'V1');
};

export const getRailsFcCalloutFlag = () => {
  return getRailsPokusConfig(RailsAbConfig.railsFcCallout, true);
};

export const getNearbyDatesNew = (forTracking = false) => {
  if (Platform.OS !== 'web' && forTracking) {
    return getRailsPokusConfigForTracking(RailsAbConfig.railsNearbyDatesRevamp, null);
  }
  return getRailsPokusConfig(RailsAbConfig.railsNearbyDatesRevamp, false);
};

export const getNearbyDatesVariants = () => {
  return getRailsPokusConfig(RailsAbConfig.railsNearbyDatesVariants, 1);
};

export const getOtherDayTrains = () => {
  return (
    getRailsPokusConfig(RailsAbConfig.railsOtherDaytrains, false) &&
    getRailsPokusConfig(RailsAbConfig.railsNearbyDatesRevamp, false)
  );
};

export const getTgLowCpBucket = () => {
  return getRailsPokusConfig(RailsAbConfig.railsTgLowCpBucket, false);
};

export const getShowRouteExtension = () => {
  return getRailsPokusConfig(RailsAbConfig.railsShowRouteExtenstion, true);
};

export const getRailsErrorHandlingConfig = (forTracking = false) => {
  if (forTracking) {
    return getRailsPokusConfigForTracking(RailsAbConfig.railsErrorHandling, null);
  }
  return getRailsPokusConfig(RailsAbConfig.railsErrorHandling, false);
};

export const getShowBNPPTooltip = () => {
  return getRailsPokusConfig(RailsAbConfig.railsShowBNPPtooltip, true); //update this pokus also for MWeb Sync
};

export const getRailsListingRetry = () => {
  return getRailsPokusConfig(RailsAbConfig.railsListingErrorRetry, false);
}

export const getRailsLDAndSSQuotaEnabled = () => {
  return getRailsPokusConfig(RailsAbConfig.railsLDAndSSQuotaEnabled, false);
};

export const getRailsIfCanLogCustomErrorsToSentry = () => {
  return getRailsPokusConfig(RailsAbConfig.railsCanLogCustomErrorsToSentry, false);
};

export const getRouteExtensionBottomSheetVariants = () => {
  return getRailsPokusConfig(RailsAbConfig.railsRouteExtenstionBottomsheetVariant, 1);
};

export const getRailsTbsErrorHandlingFlowV1 = () => {
  return getRailsPokusConfig(RailsAbConfig.railsTbsErrorHandlingFlowV1, false);
};

export const getRailsFcTgTogetherValue = () => {
  return getRailsPokusConfig(RailsAbConfig.railsFcTgTogether, 0);
}

export const getRailsAvailabilitySubscription = () => {
  return getRailsPokusConfig(RailsAbConfig.railsAvailabilitySubscription, 0);
};

export const getBusRailsPremiumConfig = () => {
  return getRailsPokusConfig(RailsAbConfig.busRailsPremium, 1);
};

export const getRailsSeatLockListingVariants = () => {
  if (!getIfCanShowBNPP()) {
    return null;
  }
  return getRailsPokusConfig(RailsAbConfig.railsSeatLockListingVariants, 1);
};

export const getRailsConnectedTravelV2Card = () => {
  return getRailsPokusConfig(RailsAbConfig.railsConnectedTravelCard, 0);
}

export const getRailsAvailDepletion = () => {
  return getRailsPokusConfig(RailsAbConfig.railsAvailDepletion, 0);
};

export const showRailsDynamicPriceIcon = () => {
  return getRailsPokusConfig(RailsAbConfig.railsDynamicPrice, 0);
};

export const showRailsReviewIrctcBs = () => {
  return getRailsPokusConfig(RailsAbConfig.railsReviewIrctcBs, 0);
};

export const getRailsFcPremiumPokus = () => {
  return getRailsPokusConfig(RailsAbConfig.railsFcPremiumPercentage, 0);
};

export const getRailsMealsRISPokus = () => {
   return false;
  return getRailsPokusConfig(RailsAbConfig.railsMealsRisDetails, false);
};

export const getRailsMealsPnrDetailsPokus = () => {
  return getRailsPokusConfig(RailsAbConfig.railsMealsPnrDetails, false);
};

export const getRailsMealsLtsDetailsPokus = () => {
  return getRailsPokusConfig(RailsAbConfig.railsMealsLtsDetails, false);
};

export const getRailsMealsThankyouDetailsPokus = () => {
   return false;
  return getRailsPokusConfig(RailsAbConfig.railsMealsTrainThankYou, false);
}

export const showNewIrctcBottomSheet = () => {
  return getRailsPokusConfig(RailsAbConfig.railsTravellerIrctcBottomsheet, 0);
};

export const showSocialProofingFc = () => {
  return getRailsPokusConfig(RailsAbConfig.railsSocialProofingFreeCancellation, 0);
};

export const showSocialProofingTg = () => {
  return getRailsPokusConfig(RailsAbConfig.railsSocialProofingTripGuarantee, 0);
};

export const showScheduleTatkal = () => {
  return getRailsPokusConfig(RailsAbConfig.railsScheduleTatkal, false);
};

export const railsCouponExperiment = () => {
  return getRailsPokusConfig(RailsAbConfig.railsCouponExperiment, 0);
};

export const railsLoggedOutCoupons = () => {
  if(checkIfHdfcSmartBuy()) {
    return 0;
  }
  return getRailsPokusConfig(RailsAbConfig.railsLoggedOutCoupons, 0);
}

export const getPwaOfferCallout = () => {
  return getRailsPokusConfig(RailsAbConfig.railsPwaOfferCallout, false);
};

export const showMealsStaticData = () => {
  return getRailsPokusConfig(RailsAbConfig.showMealsStaticData, 0);
}

export const getMealsNewFlow = () => {
  return getRailsPokusConfig(RailsAbConfig.railsMealsNewFlow, 0);
}

export const showProfileIncompleteFlowPokus = () => {
  return getRailsPokusConfig(RailsAbConfig.railsIrctcIncompleteProfileFlow, 0);
};

export const getRailsTravelplexBot = () => {
  if(checkIfHdfcSmartBuy()) {
    return 0;
  }
  return getRailsPokusConfig(RailsAbConfig.railsTravelplexBot, 0);
};

